import { styled } from '@mui/material';
import { AccountDetailsInfo } from 'src/components/banking/AccountDetailsInfo/AccountDetailsInfo';

export const StyledAccountDetailsInfo = styled(AccountDetailsInfo)({
  '.MuiButtonBase-root': {
    width: '100%'
  }
});
